/** @format */

import {Typography} from '@mui/material';

import {ColumnType} from 'components/Table/core/types';

import {toStr} from 'helpers/stringHelpers';

import {alphabeticalWithDateSorting, dateSorting} from './sortingFunctions';
import {formatDate} from './formatHelpers';
import {DateCell} from '../style';
import ValueChangeCell from '../components/ValueChangeCell';
import NameIdCell from '../components/NameIdCell';

export const formatColumns = (t: (key: string) => string): ColumnType[] => {
  return [
    {
      id: 'time',
      title: t('Дата'),
      size: 150,
      sortingFn: dateSorting,
      cell: info => (
        <DateCell>
          <Typography variant='body2'>{formatDate(toStr(info.getValue()))}</Typography>
        </DateCell>
      ),
    },
    {
      id: 'accountId',
      title: t('Субаккаунт'),
      size: 120,
      sortingFn: alphabeticalWithDateSorting,
      enableFilter: true,
      cell: info => <Typography variant='body2'>{toStr(info.getValue())}</Typography>,
    },
    {
      id: 'campaignId',
      title: t('Кампания'),
      size: 250,
      sortingFn: alphabeticalWithDateSorting,
      enableFilter: true,
      cell: info => (
        <NameIdCell name={toStr(info.row.original.campaignName)} id={toStr(info.getValue())} />
      ),
    },
    {
      id: 'adGroupId',
      title: t('Группа'),
      size: 250,
      sortingFn: alphabeticalWithDateSorting,
      enableFilter: true,
      cell: info => (
        <NameIdCell name={toStr(info.row.original.adGroupName)} id={toStr(info.getValue())} />
      ),
    },
    {
      id: 'adId',
      title: t('Объявление'),
      size: 250,
      sortingFn: alphabeticalWithDateSorting,
      enableFilter: true,
      cell: info => (
        <NameIdCell name={toStr(info.row.original.adName)} id={toStr(info.getValue())} />
      ),
    },
    {
      id: 'categoryDescription',
      title: t('Параметр изменения'),
      size: 250,
      sortingFn: alphabeticalWithDateSorting,
      enableFilter: true,
      cell: info => <Typography variant='body2'>{toStr(info.getValue())}</Typography>,
    },
    {
      id: 'typeDescription',
      title: t('Событие'),
      size: 150,
      sortingFn: alphabeticalWithDateSorting,
      enableFilter: true,
      cell: info => <Typography variant='body2'>{toStr(info.getValue())}</Typography>,
    },
    {
      id: 'changes',
      title: t('Что изменилось'),
      size: 400,
      enableHoverExpand: true,
      cell: info => (
        <ValueChangeCell
          valueBefore={info.row.original.valueBefore as Record<string, unknown>}
          valueAfter={info.row.original.valueAfter as Record<string, unknown>}
          type={toStr(info.row.original.type)}
          isExpandable={info.row.original.isExpandable as boolean}
        />
      ),
    },
  ];
};
